




























import mixins from 'vue-typed-mixins';
import QuestionVue from './Question.vue';
import { Page, Question } from '@/utils/SurveyUtils';
import {
  PageData,
  ReportContext,
  ReportNode,
  QuestionData,
} from '@/utils/ReportUtils';
import { SubOrganization } from '@/utils/SubOrganizationUtils';
import SurveyNodeUtils from '@/utils/SurveyNodeUtils';
import SurveyNextPreviousVue from '../SurveyNextPrevious.vue';
export default mixins().extend({
  name: 'node_page',
  components: {
    node_question: QuestionVue,
    SurveyNextPrevious: SurveyNextPreviousVue,
  },

  props: {
    node: {
      type: Object as () => ReportNode<Page, PageData>,
    },

    context: {
      type: Object as () => ReportContext,
    },

    suborganization: {
      type: Object as () => SubOrganization,
    },
  },

  computed: {
    visible(): boolean {
      return this.node?.data?.visible || false;
    },

    questions(): ReportNode<Question, QuestionData>[] {
      if (this.node && this.node.children.length > 0) {
        return this.node.children as ReportNode<Question, QuestionData>[];
      }
      return [];
    },

    valid(): boolean {
      return this.questions?.every((item) => item?.data.valid);
    },

    showSaveButton(): boolean {
      // some pages only contain questions of type text block, and no save function is necessary
      return this.questions
        ?.filter((node => node.item?.questiontype?.key != 'text_block')).length > 0;
    },

    conditionalVisible(): any {
      // If the page has only nodes that could be conditionally hidden (possible that the page is empty)
      if (this.questions.every((node) => node.item?.condition?.key)) {
        return this.questions
          ?.filter((node) => node.item?.condition?.key)
          .every((node) => node.data.conditional.visible === false);
      } else {
        return false;
      }
    },
  },

  methods: {
    async save() {
      try {
        this.$alert?.hide('save');
        await Promise.all(
          (this.$refs.component as any)
            .filter((component: any) => typeof component.save === 'function')
            .map((component: any) => component.save())
        );
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.default', {
            values: [this.$languageobj('model.survey.label')],
          }),
        });
      } catch (error) {
        this.$alert?.show('save', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
